import employeeSearchComponent from './employeeSearch.component';

let employeeSearchModule = angular.module('vacations-absences.employeeSearch', [])

.component('employeeSearch', employeeSearchComponent)

.name;

export default employeeSearchModule;



// WEBPACK FOOTER //
// ./client/app/components/employeeSearch/employeeSearch.js